<template>
  <section>
    <EnviaCorreoIndividual />
    <v-card class="p-0 m-0">
      <v-btn
        class="p-0 m-0"
        color="#0085AD"
        @click="abrirCerrarDialog()"
        :loading="loading"
        dark
        block
        title="Notificar faltas"
      >
        <v-icon>mail</v-icon>
        NOTIFICACIONES
      </v-btn>
    </v-card>
    <v-dialog
      persistent
      fullscreen
      v-model="dialog"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-form
          @submit.prevent="cargarFaltas(form, l_sanciones)"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <!-- Cabecera del formulario -->
          <v-card-title class="headline">
            <v-flex xs9> <v-icon>mail</v-icon> NOTIFICACIÓN FALTAS </v-flex>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="abrirCerrarDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-3">
            <v-layout row wrap>
              <v-flex xs12 md6 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.fecha_inicio"
                  label="Fecha inicio"
                  type="date"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md6 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.fecha_fin"
                  label="Fecha fin"
                  type="date"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 class="layout wrap ">
                <v-checkbox
                  v-for="sancion in l_sanciones"
                  :key="sancion.id"
                  :label="sancion.descripcion"
                  v-model="sancion.check"
                  primary
                  @change="cargarFaltas(form, l_sanciones)"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  class="p-0 m-0"
                  color="#0085AD"
                  :loading="loading"
                  dark
                  block
                  title="Notificar faltas"
                  type="submit"
                >
                  <v-icon>search</v-icon>
                  BUSCAR
                </v-btn>
              </v-flex>
              <v-flex xs12 class="pb-2">
                <CalendarioNotificaciones :key="key_historial" />
              </v-flex>
              <v-flex
                xs12
                class="text-xs-center blue--text title"
                v-if="fecha_inicio_consulta && fecha_fin_consulta"
              >
                {{ $moment(fecha_inicio_consulta).format("DD/MM/YYYY") }} -
                {{ $moment(fecha_fin_consulta).format("DD/MM/YYYY") }}
              </v-flex>
              <v-flex xs12 class="pb-1 layout wrap">
                <v-btn
                  v-if="selected.length < l_faltas.length"
                  color="#0085AD"
                  :loading="loading"
                  dark
                  title="Seleccionar todo"
                  @click="seleccionarDeseleccionarTodo(l_faltas, true)"
                >
                  <v-icon>check</v-icon>
                  Seleccionar todo
                </v-btn>
                <v-btn
                  v-if="selected.length > 0"
                  color="red"
                  :loading="loading"
                  dark
                  title="Deseleccionar todo"
                  @click="seleccionarDeseleccionarTodo(l_faltas, false)"
                >
                  <v-icon>close</v-icon>
                  Deseleccionar todo
                </v-btn>
                <EnviaCorreoMasivo
                  v-if="selected.length > 0"
                  :lista_correos="selected"
                  :parametros_notificacion="{
                    fecha_inicio: this.form.fecha_inicio,
                    fecha_fin: this.form.fecha_fin,
                    faltas: l_sanciones
                      .filter(sancion => sancion.check)
                      .map(sancion => sancion.descripcion)
                      .join(';')
                  }"
                />
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :headers="headers"
                  :items="l_faltas"
                  :no-data-text="
                    loading ? 'Cargando...' : 'No se tiene registros'
                  "
                  :loading="loading"
                  item-key="index"
                  rows-per-page-text="Filas por pagina"
                  :pagination.sync="pagination"
                  :rows-per-page-items="[5, 10, 20, 50]"
                >
                  <template v-slot:headers="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : ''
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon v-if="header.value" small>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <td>
                      <v-checkbox
                        v-model="props.item.check"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td>
                      {{ props.item.nombres }}
                    </td>
                    <td>
                      {{ props.item.correo }}
                    </td>
                    <td>
                      <v-expansion-panel>
                        <v-expansion-panel-content
                          class="panel-reducido"
                          style="background:rgb(180, 218, 233)"
                        >
                          <template v-slot:actions>
                            <v-icon>$vuetify.icons.expand</v-icon>
                          </template>
                          <template v-slot:header>
                            <div>VER DETALLE</div>
                          </template>
                          <v-card>
                            <v-card-text class="p-1">
                              <v-layout
                                v-if="props.item.loading != true"
                                align-center
                                justify-space-between
                              >
                                <table class="tabla-faltas">
                                  <tr>
                                    <th>Fecha</th>
                                    <th>Descripción</th>
                                    <th>Horario</th>
                                    <th>Hora marcada</th>
                                    <th>Falta</th>
                                  </tr>
                                  <tr
                                    v-for="marcado in props.item
                                      .control_asistencia"
                                    :key="marcado.id_persona"
                                  >
                                    <td style="width: 25%;">
                                      {{
                                        $moment(marcado.fecha_marcado).format(
                                          "DD/MM/YYYY"
                                        )
                                      }}
                                    </td>
                                    <td style="width: 25%;">
                                      {{
                                        marcado.descripcion
                                          ? marcado.descripcion
                                          : "-"
                                      }}
                                    </td>
                                    <td style="width: 25%;">
                                      {{
                                        marcado.horario ? marcado.horario : "-"
                                      }}
                                    </td>
                                    <td style="width: 25%;">
                                      {{
                                        marcado.hora_marcada
                                          ? marcado.hora_marcada
                                          : "-"
                                      }}
                                    </td>
                                    <td style="width: 25%;">
                                      {{ marcado.detalle_marcado }}
                                    </td>
                                  </tr>
                                </table>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </td>
                    <td class="text-xs-center">
                      <v-btn
                        class="p-0 m-0"
                        color="#0085AD"
                        @click="notificacionIndividual(props.item)"
                        :loading="loading"
                        dark
                        title="Notificar correo"
                        icon
                      >
                        <v-icon>mail</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import EnviaCorreoIndividual from "./EnviaCorreoIndividual.vue";
import EnviaCorreoMasivo from "./EnviaCorreoMasivo.vue";
import CalendarioNotificaciones from "./CalendarioNotificaciones.vue";

export default {
  // Variables iniciales
  components: {
    EnviaCorreoIndividual,
    EnviaCorreoMasivo,
    CalendarioNotificaciones
  },
  props: [],
  data() {
    return {
      form: {},
      fecha_inicio_consulta: null,
      fecha_fin_consulta: null,
      loading: false,
      labels: [],
      values: [],
      sw_marcado: true,

      // Variables dialog
      valid: false,
      dialog: false,
      pagination: {
        sortBy: ""
      },
      headers: [
        {
          text: "",
          value: "",
          align: "center",
          sortable: false
        },
        {
          text: "Nombre completo",
          value: "nombres",
          align: "center"
        },
        {
          text: "Correo",
          value: "correo",
          align: "center"
        },
        {
          text: "Detalle Faltas",
          value: "nro_doc",
          align: "center"
        },
        {
          text: "Acciones",
          value: "",
          align: "center"
        }
      ],
      l_faltas: [],
      l_sanciones: [],
      key_historial: 1
    };
  },
  computed: {
    // Variable para obtener el array de seleccionados
    selected() {
      return this.l_faltas.filter(falta => falta.check);
    }
  },
  async created() {
    this.form.fecha_inicio = this.$moment().format("YYYY-MM-DD");
    this.form.fecha_fin = this.$moment().format("YYYY-MM-DD");
    await this.obtenerTipoSanciones();
  },
  async mounted() {
    this.$bus.$on("actualizaHistorialNotificacion", () => {
      this.key_historial++;
    });
  },
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para cerrar o abrir el dialog
    abrirCerrarDialog() {
      this.dialog = this.dialog ? false : true;
    },
    // Metodo para abrir el dialog de notificacion individual
    notificacionIndividual(item) {
      let parametros_notificacion = {
        fecha_inicio: this.form.fecha_inicio,
        fecha_fin: this.form.fecha_fin,
        faltas: this.l_sanciones
          .filter(sancion => sancion.check)
          .map(sancion => sancion.descripcion)
          .join(";")
      };
      this.$bus.$emit(
        "openDialogNotificacionIndividual",
        item,
        parametros_notificacion
      );
    },
    // Metodo para cargar datos en la tabla sel seguimiento
    async cargarFaltas(filtros, sanciones) {
      this.loading = true;
      if (!filtros.fecha_inicio || !filtros.fecha_fin) {
        this.$message.info("No selecciono correctamente las fechas");
        this.l_faltas = [];
        this.loading = false;
        return;
      }
      if (sanciones.filter(sancion => sancion.check).length <= 0) {
        this.$message.info("No selecciono ningun tipo de falta");
        this.l_faltas = [];
        this.loading = false;
        return;
      }
      this.fecha_inicio_consulta = filtros.fecha_inicio;
      this.fecha_fin_consulta = filtros.fecha_fin;
      const lista_sanciones = sanciones
        .filter(sancion => sancion.check)
        .map(sancion => sancion.valor);
      const vec_sanciones = JSON.stringify(lista_sanciones).replace(/"/g, "'");
      try {
        var query = `SELECT * FROM planilla.fn_lista_personas_sanciones('${filtros.fecha_inicio}','${filtros.fecha_fin}',array${vec_sanciones}) AS (id_persona integer,nombres TEXT, correo TEXT, control_asistencia varchar)`;
        let res = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta: "${query}"){
                respuesta
              }
            }
          `
        });
        let l_temp = res.runQuery.respuesta;
        l_temp.forEach(element => {
          element.control_asistencia = JSON.parse(element.control_asistencia);
          element.check = false;
        });
        this.l_faltas = l_temp;
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    // Metodo para seleccionar todos los items
    seleccionarDeseleccionarTodo(items, check) {
      items.forEach(element => {
        element.check = check;
      });
    },
    async obtenerTipoSanciones() {
      try {
        this.loading = true;
        let rpta = await this.$service.graphql({
          query: `
              query{
                parametrosPlanillas(tipo:"SANCIONES",id_estado:1){
                  rows{
                    tipo
                    valor
                    descripcion
                  }
                }
              }
            `
        });
        let l_tmp = rpta.parametrosPlanillas.rows;
        // Asignamos checkbox
        l_tmp.forEach(element => {
          element.check = false;
        });
        this.l_sanciones = l_tmp;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tabla-faltas {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.9em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.9em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/components/NotificacionFaltas.vue